// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__38vfC","list":"PatternAutocomplete_list__22vQy"};